
export default {
  name: 'PublishShiftsSvg',
};
